import React, { useEffect, useState, useContext } from "react";

import userService from "../services/userService";
import { AuthContext } from "../context/AuthContext";
import ProgressBar from '../components/ProgressBar';
import axios from "axios";
import { useNavigate } from "react-router-dom";

const DashboardMain = () => {

  const navigate = useNavigate();
  const { user, setUser } = useContext(AuthContext);
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);


  useEffect(() => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    const magazine = localStorage.getItem('magazine');
    var magazine_id = null;
    if (magazine) {
      magazine_id = JSON.parse(magazine).magazine_id;
    }
    axios.get('https://dittmagasin.no/api/v2/get-dashboard',
      {
        params: { magazine_id: magazine_id },
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    )
      .then(response => {
        if (response.data.status) {
          setDashboardData(response.data.data);
        }
      })
      .catch(err => {
        console.error('Failed to fetch dashboard data:', err);
      })
      .finally(() => setLoading(false));


    if (!user) {
      // fetchProfile();
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return <p>Loading user info...</p>;
  }

  return (
    <div className="main-board">
      <div className="row">
        <div className="col-lg-6 col-sm-6">
          <div className="card overflow-hidden">
            <div className="card-body p-4">
              <h5 className="card-title mb-10 fw-semibold">Releases</h5>
              <div className="row align-items-center">
                <div className="col-6">
                  <h5 className="card-title mt-2 mb-2 fw-medium">Total Releases</h5>
                  <div className="d-flex align-items-center mb-7">
                    <span
                      className="me-1 rounded-circle bg-light-success round-20 d-flex align-items-center justify-content-center">
                      <i className="ti ti-arrow-up-left text-success"></i>
                    </span>
                    <p className="text-dark me-1 fs-3 mb-0">{dashboardData?.releases_count}</p>
                  </div>
                </div>
                <div className="col-6">
                  <h5 className="card-title mt-2 mb-2 fw-medium">Total Space Used</h5>
                  <div className="d-flex align-items-center mb-7">
                    <span
                      className="me-1 rounded-circle bg-light-success round-20 d-flex align-items-center justify-content-center">
                      <i className="ti ti-packages text-success"></i>
                    </span>
                    <p className="text-dark me-1 fs-3 mb-0">{dashboardData?.total_file_size}</p>
                  </div>
                </div>
                <div className="col-5">
                  <div className="d-flex justify-content-center">
                    <div id="grade"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-sm-6">
          <div className="card overflow-hidden">
            <div className="card-body p-4">
              <h5 className="card-title mb-10 fw-semibold">Subscriber View</h5>
              <div className="row align-items-center">
                <div className="col-12">
                  <div className="">
                    <div className="hstack gap-4 mb-2">
                      <h6 className="mb-0 flex-shrink-0 w25">Daily</h6>
                      <div className=" mt-1 w-100 h-5">
                        <ProgressBar percentage={dashboardData?.subscriber_login?.daily} height={20} variant="dark" />
                      </div>
                      <h6 className="mb-0 flex-shrink-0 w35">{dashboardData?.subscriber_login?.daily}%</h6>
                    </div>
                    <div className="hstack gap-4 mb-2">
                      <h6 className="mb-0 flex-shrink-0 w25">Monthly</h6>
                      <div className=" mt-1 w-100 h-5">
                        <ProgressBar percentage={dashboardData?.subscriber_login?.monthly} height={20} variant="dark" />
                      </div>
                      <h6 className="mb-0 flex-shrink-0 w35">{dashboardData?.subscriber_login?.monthly}%</h6>
                    </div>
                    <div className="hstack gap-4 mb-2">
                      <h6 className="mb-0 flex-shrink-0 w25">Yearly</h6>
                      <div className=" mt-1 w-100 h-5">
                        <ProgressBar percentage={dashboardData?.subscriber_login?.yearly} height={20} variant="dark" />
                      </div>
                      <h6 className="mb-0 flex-shrink-0 w35">{dashboardData?.subscriber_login?.yearly}%</h6>
                    </div>
                  </div>
                </div>
                <div className="col-5">
                  <div className="d-flex justify-content-center">
                    <div id="grade"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-8 d-flex align-items-strech">
          <div className="card w-100">
            <div className="card-body flex flex-col gap-6">
              <h6 className="card-title mb-10 fw-semibold">Profile Information</h6>
              <div className="card">
                <div className="card-body flex flex-wrap gap-3">
                  {user ? (
                    <div className="profile-info">
                      <p><strong>Username:</strong> {user.user_name}</p>
                      <p><strong>Email:</strong> {user.email}</p>
                      <p><strong>First Name:</strong> {user.first_name}</p>
                      <p><strong>Last Name:</strong> {user.last_name}</p>
                    </div>
                  ) : (
                    <p>No profile found.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardMain;
